import React, { Component } from 'react';
import Loader from 'components/Loader';

export default class LoadableError extends Component {
    componentDidMount() {
        window.location.reload();
    }

    render() {
        return <Loader theme="animation" />;
    }
}
